import { render } from "./AppButtonQuizz.vue?vue&type=template&id=18276c3c"
import script from "./AppButtonQuizz.vue?vue&type=script&lang=js"
export * from "./AppButtonQuizz.vue?vue&type=script&lang=js"

import "./AppButtonQuizz.vue?vue&type=style&index=0&id=18276c3c&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__